module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-panel"
  }, [_c('div', {
    ref: "messagesContainer",
    staticClass: "chat-panel-messages"
  }, [(_vm.initializing) ? [_vm._m(0)] : _vm._l((_vm.messages), function(message, index) {
    return [(message.role === 'system') ? _c('system-message', {
      key: 's-' + index,
      attrs: {
        "text": message.text,
        "content": message.content,
        "timestamp": message.timestamp,
        "is-last": index === _vm.messages.length - 1,
        "streaming": !!message.streaming
      },
      on: {
        "action": function($event) {
          return _vm.handleAction($event, index)
        }
      }
    }) : (message.role === 'user') ? _c('user-message', {
      key: 'u-' + index,
      attrs: {
        "text": message.text,
        "initials": _vm.userInitials,
        "timestamp": message.timestamp
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('ChatInputBar', {
    ref: "inputBar",
    attrs: {
      "loading": _vm.loading || _vm.initializing,
      "locked": !!_vm.context.chat_locked,
      "card-options": _vm.lastCardOptions
    },
    on: {
      "send": _vm.handleSend
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-skeleton-wrap"
  }, [_c('div', {
    staticClass: "chat-skeleton-avatar"
  }), _vm._v(" "), _c('div', {
    staticClass: "chat-skeleton-lines"
  }, [_c('div', {
    staticClass: "chat-skeleton-line",
    staticStyle: {
      "width": "72%"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chat-skeleton-line",
    staticStyle: {
      "width": "52%"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-2bdf7d6a","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/entry-points/create-new-entry-point/chat-panel/ChatPanel.vue
// module id = YSPm
// module chunks = 1